import $ from 'jquery';
import '../vendors/slick';

if( $( "html" ).attr("dir") == "rtl" ) {
	var rtl = true;
} else {
	var rtl = false;
}

$( '.eb-js-comparison-slider' ).slick( {
	rtl: rtl,
	draggable: false,
	swipe: false,
	arrows: false,
	asNavFor: '.eb-js-comparison-slider-thumbs',
} );

$( '.eb-js-comparison-slider-thumbs' ).slick( {
	rtl: rtl,
	arrows: false,
	slidesToShow: 6,
	focusOnSelect: true,
	variableWidth: true,
	asNavFor: '.eb-js-comparison-slider',
} );
